<router-outlet></router-outlet>
<app-toast></app-toast>
<app-voice-assistant *ngIf="uiStore.isGlobalMicActive()"></app-voice-assistant>
